module.exports = __webpack_public_path__ + "static/ABA_2020-Finalist_Commercial Broker of the Year-9a0f6fbb68923e2083f5501b657a6a9f.png";